import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import {
  type ApprovalSchemeExport,
  type ApprovalWorkflowBranchExport,
  type ApprovalWorkflowExport,
} from './approvalWorkflowExportTypes';
import { getDimensionTitle } from './getDimensionTitle';

type Node = {
  values: string[] | null;
  approvalScheme?: ApprovalSchemeExport;
  branch?: Branch;
};

type Branch = {
  dimension: string;
  nodes: Node[];
};

const convertBranch = (
  branch: ApprovalWorkflowBranchExport | undefined,
  t: TGlobalFunctionTyped,
): Branch | undefined => {
  if (!branch) {
    return undefined;
  }
  return {
    dimension: getDimensionTitle(branch.dimension, t),
    nodes: branch.nodes.map<Node>((node) => ({
      values: node.values,
      approvalScheme: node.approvalScheme,
      branch: convertBranch(node.branch, t),
    })),
  };
};

export const exportApprovalWorkflowAsJson = (
  approvalWorkflowExport: ApprovalWorkflowExport,
  t: TGlobalFunctionTyped,
) => {
  return {
    defaultApprovalScheme: approvalWorkflowExport.defaultApprovalScheme,
    branch: convertBranch(approvalWorkflowExport.branch, t),
  };
};
